import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from "@angular/core"
import { Observable, of, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngxs/store';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { environment } from '@environments/environment';
import { ProblemDetail } from '@core/models';
@Injectable()
export class NotificationHttpInterceptor implements HttpInterceptor {
    private initialSnapshot: any;
    constructor(public toasterService: ToastrService, private store: Store) {

    }
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            tap(evt => {
                if (evt instanceof HttpResponse) {
                    if (evt.body && evt.body.success)
                        this.toasterService.success(evt.body.success.message, evt.body.success.title, { positionClass: 'toast-bottom-center' });
                }
            }),
            catchError((err: any) => {
                if (err instanceof HttpErrorResponse) {
                    try {                        
                        // this.toasterService.error("Test Intercept", "Http Error", { timeOut: 5000 });
                        const reader = new FileReader();
                        reader.onload = (e: Event) => {
                            const problemDetail = JSON.parse((e.target as any).result) as ProblemDetail;
                            this.displayProblemDetailToastr(problemDetail);
                        };
                         reader.readAsText(err.error);                        

                    } catch (e) {
                        this.toasterService.error('An error occurred', '', { positionClass: 'toast-bottom-center' });
                    }
                    //log error 
                }
                return throwError(err);
            }));

    }

    displayProblemDetailToastr(problemDetail: any) {
        
        if (environment.globalHttpErrorSnackbar) {
            var error = problemDetail.errors;
            if (error !== undefined) {
                var message = error[Object.keys(error)[0]];
                this.toasterService.error(message, "Error", { timeOut: 5000 });
            }
         else  if (problemDetail.title !== undefined ) {
                
                this.toasterService.error(problemDetail.title, "Error", { timeOut: 5000 });
            }
        }
    }

}